import { inject, Injectable, Type } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

import { ColumnName, LayoutService } from './layout.service';

interface LayoutComponentConfig {
  component: Type<any>;
  inputs?: Record<string, any>;
}

interface LayoutConfig {
  leftTop?: LayoutComponentConfig;
  leftBottom?: LayoutComponentConfig;
  rightTop?: LayoutComponentConfig;
  rightBottom?: LayoutComponentConfig;
  contentHeader?: LayoutComponentConfig;
}

@Injectable({
  providedIn: 'root',
})
export class LayoutResolverService {
  private layoutService = inject(LayoutService);

  resolve(route: ActivatedRouteSnapshot): Observable<boolean> {
    const layoutData = route.data['layout'] as LayoutConfig;
    if (!layoutData) {
      return of(false);
    }
    (['leftBottom', 'rightBottom', 'leftTop', 'rightTop', 'contentHeader'] as ColumnName[]).forEach(
      (name: ColumnName) => {
        const currentConfig = layoutData?.[name as keyof LayoutConfig];

        if (currentConfig) {
          this.layoutService.loadComponent(currentConfig.component, name, currentConfig.inputs);
        } else {
          this.layoutService.resetContainer(name);
        }
      },
    );

    return of(true);
  }
}
